import styled from 'styled-components';
import Icon from 'components/Icon';
import BaseFinawardsIcon from 'components/FinawardsIcon';
import { mediaQueryLaptopMin, mediaQueryMobileLargeMin, primary400 } from 'styleUtils';
export var ProductActionsWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1277we7-0"
})(["display:flex;flex-wrap:wrap;width:100%;flex:0 0 100%;@media ", "{margin:0 0 8px;}"], mediaQueryMobileLargeMin);
export var ProductActionsList = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1277we7-1"
})(["display:flex;flex-wrap:wrap;"]);
export var ProductAction = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-1277we7-2"
})(["align-items:center;color:#111512;display:inline-flex;font-size:12px;line-height:31px;height:32px;&:not(:last-child){margin-right:12px;}@media ", "{&:not(:last-child){margin-right:16px;}}"], mediaQueryLaptopMin);
export var CheckIcon = /*#__PURE__*/styled(Icon).attrs({
  name: 'check'
}).withConfig({
  componentId: "sc-1277we7-3"
})(["fill:", ";height:16px;margin-right:5px;width:11px;"], primary400);
export var FinawardsIcon = /*#__PURE__*/styled(BaseFinawardsIcon).withConfig({
  componentId: "sc-1277we7-4"
})(["margin-left:5px;"]);